import React from 'react';
import MathJax from 'react-mathjax';
import reactStringReplace from 'react-string-replace';
import { hasMathJaxPattern } from '../../utils/Util';

/**
 * To render text with mathjax
 * Example: test $$co^2$$
 * @param {string} text with mathjax formula
 */
function Mathjax({ value }) {
    if (hasMathJaxPattern(value)) {
        const mathJaxConfig = {
            "SVG": {
                styles: {
                    ".MathJax_SVG": {
                        color: "inherit !important"
                    },
                    ".noError": {
                        color: "inherit !important"
                    }
                }
            },
            "HTML-CSS": {
                availableFonts: ["TeX"],
                preferredFont: "TeX",
                webFont: "TeX",
                imageFont: "TeX",
                styles: {
                    ".MathJax": {
                        color: "inherit !important"
                    }
                }
            }
        };

        // Convert MathJax syntax to proper LaTeX syntax
        let processedValue = value;
        processedValue = processedValue.replace(/\$([^$]+)\$/g, (match, content) => {
            // Convert _text_ to _{text} and ^text^ to ^{text}
            const latexContent = content
                .replace(/_([^_]+)_/g, '_{$1}')
                .replace(/\^([^^]+)\^/g, '^{$1}');
            return `$${latexContent}$`;
        });

        return (
            <MathJax.Provider script={null} options={mathJaxConfig}>
                {reactStringReplace(processedValue, /\$\$?(.+?)\$\$?/g, (match, i) => {
                    return <MathJax.Node key={i} inline formula={match} />;
                })}
            </MathJax.Provider>
        );
    } else {
        return value;
    }
}

export default Mathjax;
